module.exports = "<div id=\"alertBox\" *ngFor=\"let alert of alerts\" class=\"notify errorbox {{ cssClass(alert) }} alert-dismissable\">\n        <a class=\"close\" (click)=\"removeAlert(alert)\">&times;</a>\n    <h1>Warning!</h1> <span class=\"alerticon\"><img src=\"../../../../assets/icons/warning_v2.png\" alt=\"error\" /></span>\n    {{alert.message}}\n    <p>If you continue typing, you might exceed one page.</p>\n</div> "


//////////////////
// WEBPACK FOOTER
// ./src/app/main/directives/alert-exceed/alert-exceed.directive.html
// module id = ./src/app/main/directives/alert-exceed/alert-exceed.directive.html
// module chunks = main